import { ClickableText, MainTitle } from 'ck-components';
import { ForgotPasswordModal, LoginForm } from 'ck-features';
import {
  chalmersLogo,
  csuGroupPicture,
  thsLogo,
  thsOldSchool,
} from 'ck-assets';
import { useEffect, useState } from 'react';

import { useActiveStudentUnion } from 'src/utils/studentUnionUtils';
import { useAuth } from 'ck-queries';
import { useNavigate } from 'react-router-dom';

export function LoginPage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { isCsu } = useActiveStudentUnion();
  const [showPasswordModal, setShowPasswordModal] = useState(false);

  // Redirect if we have a user
  useEffect(() => {
    if (user) {
      navigate('/push-notifications/create');
    }
  }, [user, navigate]);

  return (
    <>
      <ForgotPasswordModal
        isOpen={showPasswordModal}
        setIsOpen={setShowPasswordModal}
      />
      <div className='flex h-screen w-full flex-row justify-between overflow-hidden'>
        <div className='flex h-full w-full flex-grow flex-col items-center justify-center md:min-w-[500px]'>
          <div className='m-4 flex w-full max-w-xl flex-col items-center justify-center px-4 py-8 md:m-10 md:mt-40 md:p-12'>
            <img
              src={isCsu ? chalmersLogo : thsLogo}
              alt='The Chalmers Student Union Logo'
              className='mb-6 h-[150px]'
            />
            <MainTitle label='Logga in' customStyle=' mb-6' />
            <LoginForm />
            <ClickableText
              onPress={() => setShowPasswordModal(true)}
              label='Glömt lösenord'
              customStyle='mt-10 text-base font-semibold text-center hover:cursor-pointer'
            />
          </div>
        </div>
        <img
          src={isCsu ? csuGroupPicture : thsOldSchool}
          alt='a placeholder pic'
          className='hidden h-full w-7/12 overflow-hidden object-cover object-top md:block'
        />
      </div>
    </>
  );
}
